import classNames from 'classnames';
import { observer } from 'mobx-react';
import {
  CheckboxButton as ReactAriaCheckboxButton,
  CheckboxField as ReactAriaCheckboxField,
} from 'react-aria-components/Checkbox';
import { CheckboxGroup as ReactAriaCheckboxGroup } from 'react-aria-components/CheckboxGroup';

import Icon from '../../../../../app/shared/components/Icon/Icon';
import { CheckboxGroupInput } from '../../../../../app/shared/Form';
import css from './CheckboxGroup.css';

interface CheckboxGroupProps {
  label: string;
  state: CheckboxGroupInput;
  className?: string;
}

const CheckboxGroup = observer(({ className, label, state }: CheckboxGroupProps) => {
  return (
    <ReactAriaCheckboxGroup
      className={classNames(css.root, className)}
      aria-label={label}
      value={state.value}
      onChange={state.onChange}
    >
      {state.availableValues.map((option) => (
        <ReactAriaCheckboxField value={option.value} key={option.value}>
          <ReactAriaCheckboxButton className={css.button}>
            {({ isSelected }) => (
              <>
                <span className={css.indicator}>{isSelected && <Icon name="check" className={css.icon} />}</span>
                {option.label}
              </>
            )}
          </ReactAriaCheckboxButton>
        </ReactAriaCheckboxField>
      ))}
    </ReactAriaCheckboxGroup>
  );
});

export default CheckboxGroup;
